var React = require('react');

function Wallet (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"a","d":"M0 .061h15.884v20.535H0z"})),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":1},[React.createElement("mask",{"id":"b","fill":"#fff","key":0},React.createElement("use",{"xlinkHref":"#a"})),React.createElement("path",{"fill":"#FFCF00","d":"M0 10.247c0-1.154.1-1.885 2.527-3.668C4.537 5.104 10.983.061 10.983.061v8.42h4.9v12.116H1.532c-.842 0-1.53-.68-1.53-1.506v-8.844z","mask":"url(#b)","key":1}),React.createElement("path",{"fill":"#D7B000","d":"M11.491 8v4.918L2 19l12-3.673V8z","key":2}),React.createElement("path",{"fill":"#1D1D1B","d":"M6.561 8.762c.647-.72 1.59-.975 2.11-.568.518.407.413 1.322-.233 2.043-.646.722-1.59.976-2.108.569-.518-.408-.415-1.323.231-2.044","key":3})])]);
}

Wallet.defaultProps = {"width":"16","height":"21"};

module.exports = Wallet;

Wallet.default = Wallet;
